import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { ReactNode, useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { EpicSection, SectionHeader } from '@/vdp/styles';
import commonMaxWidth from '~/constants/commonMaxWidth';
import Sections from '~/constants/sections';
import DiscountContext from '~/context/common/DiscountContext';
import {
  getAssociatedVdpEventId,
  getSearchRequestId,
  getShouldShowPriceDetails,
  getSoonestRoute,
  getUser,
  getUserAvailability,
  getVehicleDetails,
  getVehicleId
} from '~/selectors';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { logError } from '~/utilities/errorHandlers';
import PriceDetails from './PriceDetails';

const Container = styled.div.attrs({
  className: 'mt-56 mx-auto px-24 l:px-0'
})`
  max-width: ${commonMaxWidth}px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    margin-top: 85px !important;
  }
`;

type OwnProps = {
  children?: ReactNode;
  whiteBg?: boolean;
};

function PriceDetailsWrapper({ children, whiteBg }: OwnProps) {
  const { tradeIncentive } = useContext(DiscountContext);
  const associatedVdpEventId = useSelector(getAssociatedVdpEventId); // maps browser's events to vehicledetails API's events
  const searchRequestId = useSelector(getSearchRequestId); // maps browser's events to search API's events
  const deliveryPickupRouteId = useSelector(getSoonestRoute)?.routeId;
  const shouldShowPriceDetails = useSelector(getShouldShowPriceDetails);
  const { referrer } = useSelector(getUser);
  const { action } = useSelector(getUserAvailability);
  const {
    fairMarketValue = 0,
    make = '',
    marketValueLoadedDateTime = '',
    model = '',
    price = 0
  } = useSelector(getVehicleDetails);
  const vehicleId = useSelector(getVehicleId);

  return shouldShowPriceDetails ? (
    <EpicSection
      className={Sections.General}
      data-nav-section={Sections.PriceDetails}
      whiteBg={whiteBg}
    >
      <SectionHeader>Price Details</SectionHeader>
      <Container>
        <PriceDetails
          analyticsCorrelationId={associatedVdpEventId}
          searchRequestId={searchRequestId}
          availabilityAction={action}
          deliveryPickupRouteId={deliveryPickupRouteId}
          errorLogger={logError}
          fairMarketValue={fairMarketValue}
          hasTradeIncentive={tradeIncentive > 0}
          make={make}
          marketValueLoadedDateTime={marketValueLoadedDateTime}
          model={model}
          price={price}
          referrer={referrer ?? ''}
          vehicleId={vehicleId}
        />
        {children}
      </Container>
    </EpicSection>
  ) : null;
}

export default withErrorBoundary(
  PriceDetailsWrapper,
  undefined,
  undefined,
  Sections.PriceDetails
);
